import { Link } from 'react-router-dom';
import { Zap } from 'lucide-react';
import { useI18n } from '../i18n';

const Column = ({ title, children }) => (
  <div>
    <h4 className="sc-mono-eyebrow mb-4 text-slate-500">{title}</h4>
    <ul className="space-y-3">{children}</ul>
  </div>
);

const FLink = ({ to, children, testid }) => (
  <li>
    <Link to={to} data-testid={testid} className="text-sm text-slate-400 hover:text-amber-500 transition-colors">
      {children}
    </Link>
  </li>
);

export const Footer = () => {
  const { t } = useI18n();
  return (
    <footer data-testid="main-footer" className="bg-[#0B0C0E] border-t border-[#2A2F3D] pt-16 pb-10 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-10 mb-12">
          <div className="col-span-2 md:col-span-3 lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 rounded-md bg-amber-500/10 border border-amber-500/40 flex items-center justify-center text-amber-500">
                <Zap size={16} strokeWidth={2.5} />
              </span>
              <span className="font-bold text-white text-lg" style={{ fontFamily: 'Outfit, sans-serif' }}>
                STAGE<span className="text-amber-500">CREW</span>
              </span>
            </Link>
            <p className="text-sm text-slate-400 max-w-xs leading-relaxed">{t('footer.tagline')}</p>
            <div className="mt-4 inline-flex items-center gap-2 px-3 py-1 border border-[#2A2F3D] rounded-full">
              <span className="w-1.5 h-1.5 rounded-full bg-amber-500" />
              <span className="sc-mono-eyebrow text-slate-400">Catalunya · España</span>
            </div>
          </div>

          <Column title={t('footer.ofertas')}>
            <FLink to="/ofertas" testid="footer-all-jobs">{t('footer.allJobs')}</FLink>
            <FLink to="/ofertas?cat=iluminacion">Iluminación</FLink>
            <FLink to="/ofertas?cat=sonido">Sonido</FLink>
            <FLink to="/ofertas?cat=rigging">Rigging</FLink>
            <FLink to="/ofertas?cat=video">Vídeo</FLink>
            <FLink to="/ofertas?cat=produccion">Producción</FLink>
          </Column>

          <Column title={t('footer.profesionales')}>
            <FLink to="/profesionales">{t('footer.searchPros')}</FLink>
            <FLink to="/registro">{t('footer.createProfile')}</FLink>
          </Column>

          <Column title={t('footer.empresas')}>
            <FLink to="/empresas">{t('footer.searchCompanies')}</FLink>
            <FLink to="/registro">{t('footer.registerCompany')}</FLink>
            <FLink to="/ofertas">{t('footer.publishJob')}</FLink>
          </Column>

          <Column title={t('footer.comunidad')}>
            <FLink to="/actualidad" testid="footer-content-hub">{t('content.hubTitle')}</FLink>
            <FLink to="/foro" testid="footer-forum">Foro & Manuales</FLink>
            <FLink to="/legal-admin" testid="footer-legal-admin">Legal & Administración</FLink>
          </Column>

          <Column title={t('footer.stagecrew')}>
            <FLink to="/sobre" testid="footer-about">{t('footer.about')}</FLink>
            <FLink to="/contacto" testid="footer-contact">{t('footer.contact')}</FLink>
            <FLink to="/colabora" testid="footer-collaborate">{t('footer.collaborate')}</FLink>
            <FLink to="/donaciones" testid="footer-support">Donaciones</FLink>
            <FLink to="/contacto?topic=partnership" testid="footer-advertising">{t('footer.advertising')}</FLink>
          </Column>
        </div>

        <div className="pt-8 border-t border-[#2A2F3D] flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-slate-500 font-mono">{t('footer.copyright')} · Administración: Lucas Tornero</p>
          <div className="flex flex-wrap gap-6">
            <Link to="/legal#aviso" data-testid="footer-legal-notice" className="text-xs text-slate-500 hover:text-amber-500">Aviso legal</Link>
            <Link to="/legal#terminos" data-testid="footer-terms" className="text-xs text-slate-500 hover:text-amber-500">{t('footer.terms')}</Link>
            <Link to="/legal#privacidad" data-testid="footer-privacy" className="text-xs text-slate-500 hover:text-amber-500">{t('footer.privacy')}</Link>
            <Link to="/legal#cookies" data-testid="footer-cookies" className="text-xs text-slate-500 hover:text-amber-500">{t('footer.cookies')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
